import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CustomCodeInjector from './components/CustomCodeInjector';
import Home from './pages/Home';
import About from './pages/About';
import AboutGroup from './pages/AboutGroup';
import PrincipalMessage from './pages/PrincipalMessage';
import WhyUs from './pages/WhyUs';
import Admission from './pages/Admission';
import Fees from './pages/Fees';
import GalleryPage from './pages/GalleryPage';
import GalleryDetail from './pages/GalleryDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import DynamicPage from './pages/DynamicPage';
import OurPhilosophy from './pages/OurPhilosophy';
import Recognition from './pages/Recognition';
import Accreditation from './pages/Accreditation';
import CbseBoard from './pages/CbseBoard';
import InfrastructurePage from './pages/InfrastructurePage';
import BeyondClassroomPage from './pages/BeyondClassroomPage';
import OtherFacilitiesPage from './pages/OtherFacilitiesPage';
import OurProgrammesPage from './pages/OurProgrammesPage';
import ExposureCodingPage from './pages/ExposureCodingPage';
import ExtraCurriculumActivitiesPage from './pages/ExtraCurriculumActivitiesPage';
import JuniorSchoolProgrammePage from './pages/JuniorSchoolProgrammePage';
import MiddleSchoolProgrammePage from './pages/MiddleSchoolProgrammePage';
import SeniorSchoolProgrammePage from './pages/SeniorSchoolProgrammePage';
import JobApplicationForm from './pages/JobApplicationForm';
import MandatoryPublicDisclosure from './pages/MandatoryPublicDisclosure';
import PublicNotice from './pages/PublicNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CoreValuesPage from './pages/CoreValuesPage';
import AdmissionGuidelinesPage from './pages/AdmissionGuidelinesPage';
import CurriculumPage from './pages/CurriculumPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <CustomCodeInjector />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-standrews-group" element={<AboutGroup />} />
        <Route path="/about-group" element={<AboutGroup />} />
        <Route path="/why-us" element={<WhyUs />} />
        <Route path="/principals-message" element={<PrincipalMessage />} />
        <Route path="/principals-desk" element={<PrincipalMessage />} />
        <Route path="/curriculum" element={<CurriculumPage />} />
        <Route path="/facilities" element={<Navigate to="/infrastructure" replace />} />
        <Route path="/extra-curricular-activities" element={<ExtraCurriculumActivitiesPage />} />
        <Route path="/extra-curriculum-activities" element={<ExtraCurriculumActivitiesPage />} />
        <Route path="/other-facilities" element={<OtherFacilitiesPage />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/admission-guidelines" element={<AdmissionGuidelinesPage />} />
        <Route path="/fees" element={<Fees />} />
        <Route path="/fee-structure" element={<Fees />} />
        <Route path="/job-application-form" element={<JobApplicationForm />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/:slug" element={<GalleryDetail />} />
        <Route path="/article" element={<Blog />} />
        <Route path="/article/:slug" element={<BlogDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/our-programmes" element={<OurProgrammesPage />} />
        <Route path="/junior-school-programme" element={<JuniorSchoolProgrammePage />} />
        <Route path="/junior-school-programmeme" element={<JuniorSchoolProgrammePage />} />
        <Route path="/middle-school-programme" element={<MiddleSchoolProgrammePage />} />
        <Route path="/middle-school-programmeme" element={<MiddleSchoolProgrammePage />} />
        <Route path="/senior-school-programme" element={<SeniorSchoolProgrammePage />} />
        <Route path="/senior-school-programmeme" element={<SeniorSchoolProgrammePage />} />
        <Route path="/accreditation" element={<Accreditation />} />
        <Route path="/cbse-board" element={<CbseBoard />} />
        <Route path="/exposure-to-programming-and-coding-languages" element={<ExposureCodingPage />} />
        <Route path="/our-philosophy" element={<CoreValuesPage />} />
        <Route path="/core-values" element={<CoreValuesPage />} />
        <Route path="/recognition" element={<Recognition />} />
        <Route path="/infrastructure" element={<InfrastructurePage />} />
        <Route path="/beyond-classroom" element={<BeyondClassroomPage />} />
        <Route path="/student-engagement" element={<BeyondClassroomPage />} />
        <Route path="/mandatory-public-disclosure" element={<MandatoryPublicDisclosure />} />
        <Route path="/public-notice" element={<PublicNotice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/:slug" element={<DynamicPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
